import React from 'react';
import {Link, useHistory} from "react-router-dom";
import "./Header.scss"
import logo from "../../logo.png";
import { useDispatch } from 'react-redux';
import axios from "axios";

import { addProducts } from '../../features/productSlice/productSlice';
const Header = () => {
  const dispatch = useDispatch();
  let history = useHistory();
  const fetchData = async  () => {

     

    const data = await 
    axios.get(`https://med-fashion-default-rtdb.firebaseio.com/Products.json`)
    .then(function (response) {
      // handle success
       dispatch(addProducts(response.data));
      // console.log(response.data);
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    });
    history.push("/");
  
  };


    return (
        <div >
  {/* <Link to="/">
  <div className='logo'>MedFashion Online Stores</div>
  </Link> */}
  <div style={{'background-color':'#340b33'}} className="d-flex justify-content-center border mb-5" >
  <nav className='navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar mb-2'>
  <div className="container-fluid">
    <div className=" mt-2">
     
  <div className="navbar-brand" onClick={fetchData} ><span class="text-light">
  <img src={logo} className="mt-2 " style={{"height":"60px", "width":"100px"}}/>
    MEDFASHION STORES</span></div></div>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    {/* <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Link</a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Dropdown
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item" href="#">Action</a></li>
            <li><a class="dropdown-item" href="#">Another action</a></li>
            <li><hr class="dropdown-divider" /></li>
            <li><a class="dropdown-item" href="#">Something else here</a></li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled">Disabled</a>
        </li>
      </ul>
      <form class="d-flex">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
        <button class="btn btn-outline-success" type="submit">Search</button>
      </form>
    </div> */}
  </div>
</nav>
</div>
      
        </div>
    );
};

export default Header; 